/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import type { ActiveTab } from '@/types/ui';

export const APP_ROUTES: Record<ActiveTab, string> = {
    home: '/home',
    overview: '/tools/example-dashboard/overview',
    statistics: '/tools/example-dashboard/statistics',
    anomalies: '/anomalies',
    statuses: '/statuses',
    systems: '/systems',
    clients: '/clients',
    pricetrafficlight: '/price-traffic-light',
    pvprediction: '/anomalies/pv-prediction',
    waterloss: '/anomalies/water',
    baseload: '/anomalies/base-load',
    heatingenergy: '/anomalies/heating-energy',
    thermalconflict: '/tools/example-dashboard/anomalies/thermal-conflict',
    contact: '/contact',
    imprint: '/imprint',
    versions: '/versions',
    login: '/login',
    plotly: '/demo/plotly',
    chartdefinitions: '/demo/chart-definitions',
    buildingstatistics: '/demo/building-statistics',
    timeseries: '/demo/time-series',
    currentvalue: '/demo/current-value',
    intervalvalues: '/demo/interval-values',
    configuration: '/demo/configuration',
    allconfigurations: '/demo/all-configurations',
    markdown: '/demo/markdown',
    mermaid: '/demo/mermaid',
    plotlyjson: '/demo/plotly-json',
    api: '/tools/api',
    debugoverview: '/debug',
    debug: '/debug/api-calls',
    errorlog: '/debug/error-log',
    logindemo: '/demo/login',
    demo: '/demo',
    componentoverview: '/tools/component-overview',
    exampledashboards: '/tools/example-dashboard',
    layouts: '/tools/layouts',
    kpis: '/tools/kpis',
    sensorsdevices: '/tools/sensors-devices',
    devicedefinitions: '/tools/device-definitions',
    translations: '/tools/translations',
    tools: '/tools',
};

export function getActiveTabFromPathname(pathname: string): ActiveTab | null {
    const matchingEntry = Object.entries(APP_ROUTES)
        // Prefer a nested anomaly route over its /anomalies parent route.
        .sort(([, leftRoute], [, rightRoute]) => rightRoute.length - leftRoute.length)
        .find(([, routePath]) => pathname === routePath || pathname.startsWith(`${routePath}/`));

    return (matchingEntry?.[0] as ActiveTab | undefined) ?? null;
}
